module.exports = __webpack_public_path__ + "static/media/161007-DSC05069-23_Small.b0f75b20.jpg";